// extracted by mini-css-extract-plugin
export default {"rulesDetailList":"RulesDetailsList_rulesDetailList__UVIiO","ruleInactive":"RulesDetailsList_ruleInactive__V1QqO","ruleExpired":"RulesDetailsList_ruleExpired__Vl5+p"};